(function () {
    'use strict';

    angular
        .module('app.settings')
        .run(appRun);

    appRun.$inject = ['routerHelper', '$rootScope'];

    /* @ngInject */
    function appRun(routerHelper) {             
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [            
            {
                state: 'settings.usertype',
                config: {
                    url: '/usertype',
                    templateUrl: 'app/settings/usertype/settings.usertype.controller.html',
                    controller: 'UserTypeController',
                    controllerAs: 'vm',
                    title: 'User Types',
                    settings: {
                        isVisible: false,
                        nav: 5,
                        content: '<i class="fa fa-user-secret"></i> User Types'
                    },
                    data: {
                        permissions: {
                            only: ['SSO:SysAdmin'],
                            redirectTo: function () {
                                return {
                                    state: 'error.403',
                                    options: {
                                        reload: true
                                    }
                                };
                            }
                        }
                    }
                }
            }
        ];
    }
})();
